/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingData {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingData.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingData>): AwsSecurityHubFindingData {
        let obj = Object.assign(new AwsSecurityHubFindingData(), model);
        AwsSecurityHubFindingData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingData>): AwsSecurityHubFindingData {
        if (!model) return null;
        return AwsSecurityHubFindingData.newInstance(<AwsSecurityHubFindingData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingData) {
        if (!obj) return;

        models.AwsSecurityHubFindingData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingData): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.finding_created_at === "string") {
            this.finding_created_at = new Date(<string><any>this.finding_created_at);
        }
        if (typeof this.finding_updated_at === "string") {
            this.finding_updated_at = new Date(<string><any>this.finding_updated_at);
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (typeof this.first_observed_at === "string") {
            this.first_observed_at = new Date(<string><any>this.first_observed_at);
        }
        if (typeof this.last_observed_at === "string") {
            this.last_observed_at = new Date(<string><any>this.last_observed_at);
        }
        if (this.resources) {
            for (let val of this.resources) {
                models.AwsSecurityHubFindingResource.fixupPrototype(val);
            }
        }
    }

    /**
     * Corestack cloud account id
     */
    cloud_account_id: string;

    /**
     * Corestack cloud tenant id
     */
    tenant_id: string;

    /**
     * Severity label
     */
    severity: models.AwsSecurityHubSeverity;

    /**
     * Finding Id
     */
    finding_id: string;

    /**
     * Findings title
     */
    title: string;

    /**
     * Findings description
     */
    description: string;

    /**
     * Product name
     */
    product_name: string;

    /**
     * Company name
     */
    company_name: string;

    /**
     * AWS account id
     */
    aws_account_id: string;

    /**
     * Workflow status
     */
    workflow_status: models.AwsSecurityHubWorkflowStatus;

    /**
     * Record status
     */
    record_state: models.AwsSecurityHubRecordState;

    /**
     * Findings region
     */
    region: string;

    /**
     * Findings created in AWS time
     */
    finding_created_at: Date;

    /**
     * Findings updated AWS time
     */
    finding_updated_at: Date;

    /**
     * Findings created time
     */
    created_at: Date;

    /**
     * Findings updated time
     */
    updated_at: Date;

    /**
     * Impacted resources
     */
    resources: Array<models.AwsSecurityHubFindingResource>;

    /**
     * Recommendation description
     */
    recommendation_text: string;

    /**
     * Recommendation Link
     */
    recommendation_url: string;

    /**
     * Compliance status
     */
    compliance_status: models.AwsSecurityHubComplianceStatus;

    /**
     * Related Contorl ARN
     */
    compliance_related_requirements: Array<string>;

    /**
     * Associated Compliance Standards
     */
    compliance_associated_standards: Array<string>;

    compliance_security_control_id: string;

    compliance_rule: string;

    /**
     * Severity label
     */
    finding_provider_severity: models.AwsSecurityHubSeverity;

    /**
     * Resource Id
     */
    finding_provider_types: Array<string>;

    /**
     * Related findings
     */
    finding_provider_related_findings: Array<string>;

    /**
     * Findings first observed  time
     */
    first_observed_at: Date;

    /**
     * Findings last observed time
     */
    last_observed_at: Date;

    /**
     * Findings Generator Id
     */
    generator_id: string;

    /**
     * Source Corestack Account Id
     */
    source_account_id: string;

}
